import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

const HomePage = () => {
  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white flex items-center'>
      <div className='w-full max-w-6xl mx-auto px-6 py-16'>
        <Header />
        <div className='grid grid-cols-1 md:grid-cols-2 gap-12 items-center'>
          <div className='flex flex-col items-center md:items-start text-center md:text-left space-y-6'>
            <div className='inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur'>
              <span className='h-2 w-2 rounded-full bg-sky-400 shadow-[0_0_12px_rgba(56,189,248,0.9)]'></span>
              <p className='text-xs uppercase tracking-[0.28em] text-slate-200'>
                Digital wellness
              </p>
            </div>

            <h1 className='text-4xl md:text-5xl font-semibold leading-tight'>
              Guide their screen time with confidence
            </h1>
            <p className='text-slate-300 max-w-xl'>
              An effort to save children from eye sight issues, screen
              addiction, and developmental challenges. Protect their vision,
              mental health, and cognitive growth with mindful digital
              parenting.
            </p>

            <Link
              to='/nethra'
              aria-label='Go to Nethra page'
              className='relative w-full max-w-md aspect-[4/3] group'
            >
              <div className='absolute inset-0 rounded-3xl bg-gradient-to-br from-sky-500/25 via-cyan-400/15 to-indigo-500/10 blur-3xl transition-opacity duration-300 group-hover:opacity-80'></div>
              <div className='relative h-full rounded-3xl border border-white/10 bg-slate-900/60 backdrop-blur flex items-center justify-center shadow-2xl shadow-sky-900/30 transition-transform duration-300 group-hover:-translate-y-1'>
                <img
                  src='/assets/eye.png'
                  alt='Alert eye watching over usage'
                  className='w-64 h-64 object-contain drop-shadow-[0_20px_35px_rgba(0,0,0,0.45)]'
                />
              </div>
            </Link>
          </div>
          <div className='flex flex-col items-center md:items-start text-center md:text-left space-y-6'>
            <div className='inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur'>
              <span className='h-2 w-2 rounded-full bg-amber-400 shadow-[0_0_12px_rgba(251,191,36,0.9)]'></span>
              <p className='text-xs uppercase tracking-[0.28em] text-slate-200'>
                Secure & Private
              </p>
            </div>
            <h1 className='text-4xl md:text-5xl font-semibold leading-tight'>
              Your child's brain, protected
            </h1>
            <p className='text-slate-300 max-w-xl'>
              We prioritize your child's privacy and data security. Nethra
              operates with end-to-end encryption, ensuring that all personal
              information and usage data remain confidential and protected from
              unauthorized access.
            </p>
            <Link
              to='/thrinethra'
              aria-label='Go to ThriNethra page'
              className='relative w-full max-w-md aspect-[4/3] group'
            >
              <div className='absolute inset-0 rounded-3xl bg-gradient-to-tr from-amber-400/20 via-fuchsia-500/15 to-sky-500/20 blur-3xl transition-opacity duration-300 group-hover:opacity-80'></div>
              <div className='relative h-full rounded-3xl border border-white/10 bg-white/5 backdrop-blur flex items-center justify-center shadow-2xl shadow-fuchsia-900/25 transition-transform duration-300 group-hover:-translate-y-1'>
                <div className='relative w-64 h-64'>
                  <div className='absolute inset-4 rounded-full bg-gradient-to-br from-indigo-400/30 via-cyan-300/20 to-sky-400/25 blur-2xl'></div>
                  <img
                    src='/assets/eye-to-face.png'
                    alt='Protected brain'
                    className='w-64 h-64 object-contain drop-shadow-[0_20px_35px_rgba(0,0,0,0.45)]'
                  />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
